import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=09f628b6&scoped=true&"
import script from "./FormCustomer.vue?vue&type=script&lang=js&"
export * from "./FormCustomer.vue?vue&type=script&lang=js&"
import style0 from "./FormCustomer.vue?vue&type=style&index=0&id=09f628b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f628b6",
  null
  
)

export default component.exports